import React, { lazy, Suspense, useContext } from "react";
import TfSale from "./snapshots/TfSale";
import EntityContext from "../../../../context/entityContext";
import authService from "../../../../services/authService";

const TfPurchase = lazy(() => import("./snapshots/TfPurchase"));

export default function TradeFinanceSnapshot() {

  const { constants } = authService.getCurrentUser();
  const { selectedBusinessType } = useContext(EntityContext);

  return (
    <>
      {selectedBusinessType == constants.BUSINESS_TYPE.PURCHASE ? (
        <Suspense fallback={<div>Loading...</div>}>
          <TfPurchase />
        </Suspense>
      ) : (
        <TfSale />
      )}
    </>
  )
}